<template lang="pug">
    mt-header(:title="title")
        div(slot="left", @click="backHandle", v-if="back")
            mt-button(icon="back") 返回
        mt-button(slot="right", @click="submitHandle", v-if="isRightSubmit") {{subText}}
</template>
<script>
    export default {
        props: {
            back: {
                type: Boolean,
                default: true
            },
            title: {
                required: true,
                type: String
            },
            subText: {
                type: String,
                default: '提交'
            },
            isRightSubmit: {
                type: Boolean,
                default: true
            }
        },
        methods: {
            backHandle () {
                this.$router.back()
            },
            submitHandle () {
                this.$emit('submitHandle')
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/header.vue